import React from 'react';
import styles from './StartButton.module.css';

interface StartButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export const StartButton: React.FC<StartButtonProps> = ({ isOpen, onClick }) => {
  return (
    <button
      className={`${styles.startButton} ${isOpen ? styles.active : ''}`}
      onClick={onClick}
      aria-label="Start menu"
      aria-expanded={isOpen}
      aria-haspopup="menu"
    >
      {/* Windows logo */}
      <img
        src="/icons/windows-logo.png"
        alt="Windows"
        className={styles.logo}
      />
      <span className={styles.text}>start</span>
    </button>
  );
};

export default StartButton;
